// dhs.js.liquid
console.log('[dhs.js] loaded and executing');
//
// 1) NEW: Listen for only the password‐form submit
//
document.addEventListener('submit', async e => {
  if (e.target.id === 'dhs-password-form') {
    e.preventDefault();
    console.log('[dhs.js] password form submitted — proceeding with update');
    await proceedWithUpdate();
  }
});

//
// 2) The new “glue” function that
//    • pulls values from both forms
//    • creates the customer token
//    • updates the customer
//
async function proceedWithUpdate() {
  // 2a) Grab the field values from the edit form
  const editForm = document.getElementById('edit-profile-form');
  const firstName = editForm.firstName.value;
  const lastName  = editForm.lastName.value;
  const email     = editForm.email.value;
  // 2b) Grab the password the user just typed
  const password  = document.getElementById('password-input').value;

  console.log('[EditProfile] values:', { firstName, lastName, email, password: !!password });

  try {
    // 3) Create (or reuse) the customerAccessToken
    console.log('[EditProfile] about to call customerAccessTokenCreate…');
    const loginQuery = `
      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
          customerAccessToken { accessToken }
          userErrors { field message }
        }
      }`;
    let resp = await fetch('/api/2025-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '941f79cd2d3c890e23d9e8b314da9649'
      },
      body: JSON.stringify({
        query: loginQuery,
        variables: { input: { email, password } }
      })
    });
    let { data: loginData, errors: loginErrors } = await resp.json();
    const tokenErrors = [
      ...(loginErrors || []),
      ...(loginData.customerAccessTokenCreate.userErrors || [])
    ].map(e => e.message);
    if (tokenErrors.length) throw new Error('Login failed: ' + tokenErrors.join('; '));
    const customerToken = loginData.customerAccessTokenCreate.customerAccessToken.accessToken;
    console.log('[EditProfile] got customerAccessToken:', customerToken);

    // 4) Now run the update mutation
    console.log('[EditProfile] about to call customerUpdate…');
    const updateQuery = `
      mutation customerUpdate($customer: CustomerUpdateInput!, $token: String!) {
        customerUpdate(customer: $customer, customerAccessToken: $token) {
          customer { firstName lastName email }
          userErrors { field message }
        }
      }`;
    resp = await fetch('/api/2025-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '941f79cd2d3c890e23d9e8b314da9649'
      },
      body: JSON.stringify({
        query: updateQuery,
        variables: {
          customer: { firstName, lastName, email },
          token: customerToken
        }
      })
    });
    const { data: updateData, errors: updateErrors } = await resp.json();
    const userErrs = updateData.customerUpdate.userErrors.map(u => u.message);
    if (userErrs.length) throw new Error('Update failed: ' + userErrs.join('; '));

    // 5) Success!
    alert('Profile updated.');
    location.reload();

  } catch (err) {
    console.error('[EditProfile] error:', err);
    alert('Could not update profile:\n' + err.message);
  }
}

